import { AreaComumDiaStatus } from "core/features/area-comum/typings";
import { AreaComumHorario } from "core/features/area-comum/typings/index";
import React, { useLayoutEffect } from "react";
import moment from "moment";
import { showError } from "infra/helpers/alerta";
import { Box } from "@chakra-ui/react";
import CalendarioReserva from "../CalendarioReserva";

function FormCalendario({
  value,
  onChange,
  setDataInicio,
  setDataFim,
  disabledDates,
  datas,
  dataFim,
  dataInicio,
}: {
  value: any;
  onChange: any;
  setDataInicio: any;
  setDataFim: any;
  datas: AreaComumHorario[] | undefined;
  dataInicio: string;
  dataFim: string;
  disabledDates?: string[];
}) {
  useLayoutEffect(() => {
    if (datas?.length) {
      const clearAndAddClasses = (
        el: Element | null,
        classesToAdd: string[]
      ) => {
        if (el) {
          el.classList.remove(`event-${AreaComumDiaStatus.Bloqueado}`);
          el.classList.remove(`event-${AreaComumDiaStatus.Livre}`);
          el.classList.remove(`event-${AreaComumDiaStatus.Ocupado}`);
          el.classList.remove(`event-${AreaComumDiaStatus.Parcialmente}`);
          el.classList.remove("event-selected");
          el.classList.remove("event-unavailable");
          classesToAdd.forEach((classToAdd) => {
            if (classToAdd !== "") el.classList.add(classToAdd);
          });
        }
      };

      let startDate = dataInicio;
      for (
        startDate;
        moment(startDate).subtract(1, "day").format("YYYY-MM-DD") !== dataFim;
        startDate = moment(startDate).add(1, "day").format("YYYY-MM-DD")
      ) {
        // eslint-disable-next-line no-loop-func
        const apiDate = datas.find((d) => d.data === startDate);
        const modal = window.document.getElementById("form-calendario-reserva");
        const el = modal!.querySelector(`[data-date='${startDate}']`);

        if (
          apiDate &&
          moment(startDate).isSameOrAfter(moment().format("YYYY-MM-DD"), "day")
        ) {
          const isSelectedDate = moment(startDate).isSame(value, "day");
          const classesToAdd = [`event-${apiDate.status}`];
          isSelectedDate && classesToAdd.push(`event-selected`);
          clearAndAddClasses(el, classesToAdd);
        } else {
          const status = apiDate?.status;
          clearAndAddClasses(el, [
            "event-unavailable",
            status ? `event-${status}` : "",
          ]);
        }
      }
    }
  }, [dataFim, dataInicio, datas, value]);

  return (
    <Box id="form-calendario-reserva">
      <CalendarioReserva
        onChangeDate={(start, end) => {
          setDataInicio(start.replace(/[/]/g, "-"));
          setDataFim(end.replace(/[/]/g, "-"));
        }}
        dateClick={(v) => {
          if (moment(v).isBefore(moment(), "day")) {
            showError(
              "Essa data está bloqueada pois é de um dia anterior a hoje."
            );
            return;
          }
          const apiDate = datas?.find((d) =>
            moment(d.data).isSame(moment(v), "day")
          );
          if (apiDate?.status === AreaComumDiaStatus.Ocupado) {
            showError(`Essa data esta bloqueada. ${apiDate?.motivo || ""}`);
          } else {
            if (!disabledDates?.includes(v)) {
              onChange(v);
            } else {
              showError(
                "A área comum está bloqueada para essa data. Ela foi bloqueada pela administração ou não abre nesse dia."
              );
            }
          }
        }}
        reservas={[]}
        onClick={(v) => {}}
        search={""}
        onSearch={() => {}}
        hideSearch
        hideOptionsView
      />
    </Box>
  );
}

export default React.memo(FormCalendario);
